import { Helmet } from 'react-helmet-async';

export function SEO({ title, description, image, url, type = 'website' }) {
  const siteName = 'Ready Set STEM';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} — STEM Education for K-12`;
  const defaultDesc = 'STEM.org accredited K-12 STEM education platform. Science, Technology, Engineering, Math & Robotics courses for grades K-8 in Aurora, Naperville & Fox Valley IL.';
  const desc = description || defaultDesc;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
